import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v2`;
const main = "BytePro";
const sub = "LoanPayment";

class LoanPaymentService {
  getLoanPaymentsWithFilter(loanNumber, pageNumber, pageSize, paidStatus) {
    return axios
      .get(
        `${API_URL}/${main}/${sub}/Filter?loanNumber=${loanNumber}&pageNumber=${pageNumber}&pageSize=${pageSize}&paidStatus=${paidStatus}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response;
      });
  }
}

export default new LoanPaymentService();
